import React from 'react';
import Svg, {Path} from 'react-native-svg';

function CopySvg({color = '#0065DB', ...props}) {
    return (
        <Svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
            <Path
                d="M5.5 2.5h6a2 2 0 012 2v6a2 2 0 01-2 2h-6a2 2 0 01-2-2v-6a2 2 0 012-2z"
                stroke={color}
                strokeWidth={1.5}
            />
            <Path
                d="M3.5 5.5h-1a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1v-1"
                stroke={color}
                strokeWidth={1.5}
                strokeLinecap="round"
            />
        </Svg>
    );
}

export default CopySvg;
